import { ReactNode } from "react";
import classNames from "classnames";
import { Drawer } from "app/components/ui/drawer/Drawer";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import IconClose from "app/pages/.shared/IconClose";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./SearchDrawer.scss";

type SearchDrawerProps = {
	isOpen: boolean;
	onClose: () => void;
	title: string;
	paddedBody?: boolean;
	hasPreviousStep: boolean;
	onPrevious: () => void;
	transitionDirection: "forward" | "backward";
	transitionKey: string;
	children: ReactNode;
};

export const SearchDrawer = ({
	isOpen,
	onClose,
	title,
	paddedBody = true,
	hasPreviousStep,
	onPrevious,
	transitionDirection,
	transitionKey,
	children,
}: SearchDrawerProps) => {
	const transitionClassName =
		transitionDirection === "backward"
			? "search-drawer__step-transition--backward"
			: "search-drawer__step-transition--forward";

	return (
		<Drawer.Root open={isOpen}>
			<Drawer.Content
				className="search-drawer__content"
				overlayClassName="search-drawer__overlay"
			>
				<Drawer.Header showClose={hasPreviousStep} onClose={onPrevious}>
					<div
						key={`header-${transitionKey}`}
						className={classNames(
							"search-drawer__step-transition",
							transitionClassName
						)}
					>
						<Typography
							variant={TYPOGRAPHY_VARIANTS.XL}
							isBold
							className="search-drawer__title"
							component="h2"
						>
							{title}
						</Typography>
					</div>

					{/* @ts-expect-error Drawer.Close is not typed correctly */}
					<Drawer.Close asChild>
						<Button
							// @ts-expect-error Button is not typed correctly onClick is not typed correctly
							onClick={onClose}
							variant={BUTTON_VARIANTS.BORDERLESS}
							size={BUTTON_SIZES.LARGE}
							icon={<IconClose width={20} height={20} />}
							className="search-drawer__close-button"
						/>
					</Drawer.Close>
				</Drawer.Header>

				<Drawer.Body
					className={classNames("search-drawer__body", {
						"search-drawer__body--padded": paddedBody,
					})}
				>
					<div
						key={`body-${transitionKey}`}
						className={classNames(
							"search-drawer__step-transition",
							transitionClassName
						)}
					>
						{children}
					</div>
				</Drawer.Body>
			</Drawer.Content>
		</Drawer.Root>
	);
};
